export default __webpack_public_path__ + "static/media/long.d923842d.jpg";